// Event Types.
export const EVENT_TYPES = {
    SERVER_CONTACT: 'EventServerContact',
    LAST_RECORD: 'EventLastRecord',
};

// Time Formats.
export const TIME_FORMATS = {
    HOUR_MINUTE: 'HH:mm',
    DAY_NAME: 'cccc',
    DATE_KEY: 'yyyy_D',
};

// Calendar Settings.
export const CALENDAR_SETTINGS = {
    DAYS_IN_WEEK: 7,
    MINUTES_IN_HOUR: 60,
    HOURS_IN_DAY: 24,
    MILLISECONDS_IN_DAY: 24 * 60 * 60 * 1000,
};

export const MINUTES_IN_DAY = CALENDAR_SETTINGS.HOURS_IN_DAY * CALENDAR_SETTINGS.MINUTES_IN_HOUR;
export const MINUTES_IN_WEEK = CALENDAR_SETTINGS.DAYS_IN_WEEK * MINUTES_IN_DAY;

// Block Default Values.
export const BLOCK_DEFAULTS = {
    warningLevel: 0,
    alarmLevel: 0,
    correction: 0,
    name: '',
};

export const MIN_BLOCK_DURATION_MINUTES = 30;

// Template Settings.
export const TEMPLATE_SETTINGS = {
    EXTEND_TEMPLATE_DAYS: 3,
};

export const MAX_NAME_LENGTH = 10;
